import { notification } from "antd";

const openNotification = (type = "info", message, description) => {
  notification[type]({
          message,
          description,
          placement: 'topRight',
          duration: 3, // Keeps the notification for 3 seconds
  });
};

export default openNotification;
